import { useEffect } from 'react';
import './NifiReport.scss';
import NifiReportComponent from 'componentsV2/NifiReport/NifiReport';

const NifiReport = () => {
  
  useEffect(() => {
    document.title = 'Nifi Report';
  }, []);
  
  return (
    <div className="nifi-report-page" data-testid="nifi-report-page">
      <NifiReportComponent />
    </div>
  );
};

export default NifiReport;
